import { http } from '@/services/http_service';
export default {
    getUsersRank(context)
    {
        return http()
        .post("/auth/point_ranking")
        .then((response) => {
            //context.commit('setMessages', response.data)
            //console.log(response.data)
            //console.log("넘겨받은 데이터 확인",data);
            context.commit('setUsersRank', response.data.ranking)
            return response.data.ranking;
        },function(error){
            console.log(error.response.data)
        });
    },
    getPassword(context,data) {        
        return http()
        .post("/auth/getPassword",data)
        .then((response) => {            
            //console.log("넘겨받은 데이터 확인",response.data);
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });        
    },   
    updateProfile(context,data)
    { 
        return http()
        .post("/auth/updateProfile",data)
        .then((response) => {             
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });       
    },
    sendEmailToken(context,data)
    { 
        
        return http()
        .post("/auth/sendEmailToken",data)
        .then((response) => {             
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });       
    }, 
    resetPassword(context,data)
    {         
        return http()
        .post("/auth/resetPassword",data)
        .then((response) => {             
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });       
    }, 
    getUserID(context,data)
    {
        //아이디 찾기
        return http()
        .post("/auth/findID",data)
        .then((response) => {         
            
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });     
    },
    //인증정보
    authInfo(context,data)
    {         
        return http()
        .post("/auth/authInfo",data)
        .then((response) => {             
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });       
    }, 
    //본인인증 인증번호 받기
    reqMobileauth(context,data)
    {         
        return http()
        .post("/auth/selfAuth/reqMobileauth",data)
        .then((response) => {             
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });       
    }, 
    reqEmailauth(context,data)
    {         
        return http()
        .post("/auth/selfAuth/reqEmailauth",data)
        .then((response) => {             
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });       
    }, 
    //인증번호 확인
    ckAuthToken(context,data)
    {         
        return http()
        .post("/auth/selfAuth/confirm",data)
        .then((response) => {             
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });       
    }, 
    selfAuthStore(context,data)
    {         
        return http()
        .post("/auth/selfAuth/store",data)
        .then((response) => {             
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });       
    }, 
    // updateOnlineUsers(context,data)
    // {
    //     return http()
    //     .post("/connect/updateOnlineUsers",data)
    //     .then((response) => {         
    //         console.log('온라인상태유저 업데이트',response);
    //         context.commit('setConnetcionUsers', data)
    //         return response.data;
    //     },function(error){
    //         console.log(error.response.data);
    //         return error.response.data;
    //     });     
    // }, 
    // getOnlineUsers(context,data)
    // {
    //     return http()
    //     .post("/connect/getOnlineUsers",data)
    //     .then((response) => {         
            
    //         return response.data;
    //     },function(error){
    //         console.log(error.response.data);
    //         return error.response.data;
    //     });     
    // }
    
}
